<template>
  <div
    class="header py-4"
    :class="{ [`bg-${$props.variant}`]: $props.variant }"
  >
    <b-container>
      <div class="header-body py-1 d-flex align-items-center">
        <h2 v-if="!!$slots.title" class="header-title mr-3 mb-0">
          <slot name="title"></slot>
        </h2>

        <slot />
      </div>
    </b-container>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseHeader',
  props: {
    variant: {
      type: String,
      default: 'white'
    }
  }
})
</script>
